// Home.jsx
import React from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import teamPhoto from '../../images/team/foto2026.jpg';
import { useLanguage } from '../../context/LanguageContext';

function Home() {
  const { t } = useLanguage();

  return (
    <main className="home-container">
      {/* Seção principal */}
      <section className="hero-section">
        <h1>{t('homeTitle')}</h1>
        <p>{t('homeIntro')}</p>

        <div className="lab-photo-container">
          <img
            src={teamPhoto}
            alt="Lab Team"
            className="lab-photo"
          />
        </div>
      </section>

      {/* Seção Highlights */}
      <section className="highlights-section">
        <h2>{t('highlights')}</h2>

        <div className="highlight">
          <h3>{t('qsarTitle')}</h3>
          <p>{t('qsarText')}</p>
          <Link to="/research" className="highlight-link">
            {t('seeWhatWePublished')}
          </Link>
        </div>

        <div className="highlight">
          <h3>{t('ourResourcesTitle')}</h3>
          <p>{t('ourResourcesText')}</p>
          <Link to="/tools" className="highlight-link">
            {t('browseOurTools')}
          </Link>
        </div>

        <div className="highlight">
          <h3>{t('ourTeamTitle')}</h3>
          <p>{t('ourTeamText')}</p>
          <Link to="/team" className="highlight-link">
            {t('meetOurTeam')}
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Home;
